export const APPRAISAL_INFO_LIST = [
	{
		key: 'onTimeScore',
		label: '근무시간을 잘 지키는가?',
		value: 0,
	},
	{
		key: 'attitudeScore',
		label: '적극적인 태도로 노동을 하는가?',
		value: 0,
	},
	{
		key: 'friendlyScore',
		label: '사람들과 잘 지내는가?',
		value: 0,
	},
	{
		key: 'responsibilityScore',
		label: '센스를 발휘해 작업하는가?',
		value: 0,
	},
	{
		key: 'evaluationScore',
		label: '총',
		value: 0,
		className: 'font-semibold',
	},
	{
		key: 'commentEvaluation',
		label: '자유 평가',
		value: '-',
		className:
			'border-t border-softPeach pt-2.5 block [&>div:last-child]:mt-2.5 [&>div:first-child]:font-semibold [&>div:last-child]:whitespace-pre-wrap [&>div:last-child]:max-h-[300px] [&>div:last-child]:overflow-y-auto',
	},
];
